// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__xfEgQ","textWrapper":"styles_textWrapper__HjOgE"};